export const ADMIN_ROLE = 'ADMIN'
export const MANAGER_ROLE = 'MANAGER'
export const ROLE_LABELS = {
  dispatcher: 'Dispecher',
  deliverer: 'Haydovchi',
}
